import React, { useState } from "react";
import tw from "tailwind-styled-components";
import {

  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import AddNotice from "../../Components/Notice/AddNotice";
import ComingSoon from "../../Components/ComingSoon";

const Notice = () => {
  const [isAddNotice, setIsAddNotice] = useState(false);
  const handleAddNoticeClose = () => {
    setIsAddNotice(false);
  };
  return (
    <BoxContainer>
      <div className="mt-4">
        <ComingSoon />
      </div>
    </BoxContainer>
  );
};
const BoxContainer = tw.div`Container py-6 relative`;
const Content = tw.div`text-center p-8 sm:p-12 max-w-xl w-full absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2`;
const Subtitle = tw.p`text-base sm:text-lg text-gray-600`;
const Card = tw.div`bg-white shadow-lg rounded-2xl p-4 w-full mx-auto mt-6 border border-gray-200`;
const Title = tw.h2`text-xl font-bold text-gray-800 mb-2`;
const Description = tw.p`text-gray-600 mb-4`;
const MetaInfo = tw.div`text-sm text-gray-500 mb-2`;
const ContentWrapper = tw.div`grid md:grid-cols-3 grid-cols-1 gap-4`;
const Image = tw.img`w-full object-cover rounded-lg`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm`;

export default Notice;